"use client";

import Image from "next/image";

import Heading from "@/components/heading/heading"

import Hotels from "@/public/svg/itinerary/hotels.svg";
import Meals from "@/public/svg/itinerary/meals.svg";
import Guide from "@/public/svg/itinerary/tour-guide.svg";
import Optional from "@/public/svg/itinerary/optional.svg";
import Shopping from "@/public/svg/itinerary/shopping.svg";
import Personal from "@/public/svg/itinerary/personal.svg";



import Tickets from "@/public/svg/itinerary/siteticket.svg";
import Transfers from "@/public/svg/itinerary/tranfer.svg";
import Flights from "@/public/svg/itinerary/flights.svg";

import "./inclusion.scss";

const Inclusions = () => {
    const InclusionsList = [
        {
            name: "4 Nights Accommodation",
            icon: Hotels,
        },
        {
            name: "Flights",
            icon: Flights,
        },
        {
            name: "All 3 Meals",
            icon: Meals,
        },
        {
            name: "Airport & Sightseeing Transfers",
            icon: Transfers,
        },
        {
            name: "Licensed Tour Guide",
            icon: Guide,
        },
    ];
    const ExclusionList = [
        {
            name: "Optional Excursions",
            icon: Optional,
        },
        {
            name: "Shopping",
            icon: Shopping,
        },
        {
            name: "Personal expenses",
            icon: Personal,
        },
        {
            name: "Sightseeing Entry Tickets",
            icon: Tickets,
        },
    ];
    return (
        <div className="inclusion-exclusion-block flex flex-col gap-6 py-9 relative">
            <span id="inclusion" className="anchor"></span>
            <div className="inclusion-block flex flex-col gap-4">
                <Heading as="h4">Inclusions</Heading>
                <ul className="inclusion-list inclusion-exclusion-list flex flex-wrap gap-3 items-center">
                    {InclusionsList.map((i, index) => {
                        return (
                            <li className="inclusion-list-item inclusion-exclusion-list-item flex items-center p-3 gap-2" key={index}>
                                <figure className="shrink-0">
                                    <Image loading="lazy"
                                        src={i.icon}
                                        alt={i.name}
                                        width={44}
                                        height={44}
                                    />
                                </figure>
                                <span className="font-medium">{i.name}</span>
                            </li>
                        );
                    })}
                </ul>
            </div>
            <div className="exclusion-block flex flex-col gap-4">
                <Heading as="h4">Exclusion</Heading>
                <ul className="exclusion-list inclusion-exclusion-list flex flex-wrap gap-3 items-center">
                    {ExclusionList.map((e, index) => {
                        return (
                            <li className="exclusion-list-item inclusion-exclusion-list-item flex items-center p-3 gap-2" key={index}>
                                <figure className="shrink-0">
                                    <Image loading="lazy"
                                        src={e.icon}
                                        alt={e.name}
                                        width={44}
                                        height={44}
                                    />
                                </figure>
                                <span className="font-medium">{e.name}</span>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

export default Inclusions;
